var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingPyment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33vy86u6ha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#F4B146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.727 18.876a1.273 1.273 0 1 1 2.546 0 1.273 1.273 0 0 1-2.546 0zM14 7.838a1.327 1.327 0 0 1 1.324 1.416l-.314 6.526a1.018 1.018 0 0 1-1.01.943 1.018 1.018 0 0 1-1.01-.943l-.313-6.526A1.326 1.326 0 0 1 14 7.838z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33vy86u6ha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingPyment);
export default __webpack_public_path__ + "static/media/pendingPyment.59bbca7c74a7145258b79280efdbbf89.svg";
export { ForwardRef as ReactComponent };